import React from 'react';
import { Table } from 'antd';
import type { TableProps } from 'antd';
import { useNarrowScreen } from '../hooks/useNarrowScreen';
import RecordCards from './RecordCards';

/** 桌面渲染原表格；窄屏用记录卡片，行操作与列定义保持一致。 */
function AdaptiveTable<T extends object>(props: TableProps<T>) {
  const narrow = useNarrowScreen();
  if (!narrow) return <Table<T> {...props} />;
  return <RecordCards<T> {...props} />;
}

export default AdaptiveTable;
